<form
  class="needs-validation"
  novalidate
  [formGroup]="loginForm"
  (ngSubmit)="submitLoginForm()"
  #loginFormRef="ngForm"
  autocomplete="off"
>
  <div class="mb-3">
    <input-field
      [id]="'email'"
      [label]="'Email address'"
      [type]="'email'"
      formControlName="email"
      [placeholder]="'Enter email'"
      [requiredLabel]="true"
      [errormessage]="
        loginForm.get('email')?.hasError('required')
          ? 'Enter your email address.'
          : loginForm.get('email')?.hasError('pattern')
            ? 'That doesn\'t look like a valid email address.'
            : ''
      "
      [customClass]="
        !this.loginForm.controls['email'].valid && loginFormRef?.submitted
          ? 'is-invalid'
          : this.loginForm.controls['email'].valid && loginFormRef?.submitted
            ? 'is-valid'
            : ''
      "
    ></input-field>
  </div>

  <div class="mb-3 position-relative" (keydown)="onPasswordKeyEvent($event)" (keyup)="onPasswordKeyEvent($event)">
    <input-field
      [id]="'password'"
      [label]="'Password'"
      [type]="'password'"
      formControlName="password"
      [placeholder]="'Enter your password.'"
      [requiredLabel]="true"
      [spellcheck]="false"
      [errormessage]="
        loginForm.get('password')?.errors?.['required']
          ? 'Password is required'
          : loginForm.get('password')?.errors?.['minlength']
            ? 'Min 8 characters are required'
            : loginForm.get('password')?.errors?.['maxlength']
              ? 'Max 15 characters are allowed'
              : ''
      "
      [customClass]="
        !this.loginForm.controls['password'].valid && loginFormRef?.submitted
          ? 'is-invalid'
          : this.loginForm.controls['password'].valid && loginFormRef?.submitted
            ? 'is-valid'
            : ''
      "
    >
    </input-field>

    @if (isCapsLockOn) {
      <div class="caps-lock-hint d-flex align-items-center gap-1 mt-1 text-warning">
        <i class="pi pi-exclamation-triangle"></i>
        <small>Caps Lock is on</small>
      </div>
    }
  </div>

  <div class="form-check form-control-sm">
    <input class="form-check-input" type="checkbox" formControlName="rememberMe" id="flexCheckDefault" />
    <label class="form-check-label fw-300" for="flexCheckDefault"> Keep me signed in on this device </label>
  </div>

  <p-button
    id="loginButton"
    type="submit"
    class="d-block mt-4 mx-auto mb-2"
    [styleClass]="'w-100 p-3 rounded-4 bg-primary'"
  >
    @if (isLoading()) {
      Signing in...
      <span class="spinner-border spinner-xs ms-2" role="status" aria-hidden="true"> </span>
    } @else {
      Sign in
    }
  </p-button>

  <p class="fs-14 m-0 text-center text-gray-300">Authorized personnel only. Activity is monitored</p>
</form>
